import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { bem } from 'helpers/class-name';
import { Card } from 'components/Card';
import Roster from 'components/Roster';
import EmptyList from '../../EmptyList';
import messages from '../../ManageServices.messages';
import ResourcesListItem from '../ResourcesListItem';

const { block } = bem('resources-list');

const ResourcesList = ({ resources, isLoading }) => {
  const blockClasses = block('mb-0');

  if (isLoading || _isEmpty(resources)) {
    return (
      <Card className={blockClasses} loading={isLoading} centered>
        <EmptyList
          header={messages.empty.resourcesHeader}
          text={messages.empty.resourcesText}
          button={messages.addBtn.resource}
        />
      </Card>
    );
  }

  return <Roster data={resources} RowComponent={ResourcesListItem} getKey={({ id }) => id} className={blockClasses} />;
};

ResourcesList.propTypes = {
  resources: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      capacity: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
};

export default ResourcesList;
